"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function PaperPlane24Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", d: "M22.5.79a.997.997 0 0 1 .987 1.162.992.992 0 0 1-.08.26l-8.99 20.554a1 1 0 0 1-1.77.122l-4.37-7.135L.994 11.47a1 1 0 0 1 .12-1.784L22.09.878a1 1 0 0 1 .41-.087Zm-4.439 3.95L3.727 10.758l5.12 3.01 9.215-9.03ZM10.27 15.174l9.25-9.062-6.167 14.097-3.083-5.035Z", clipRule: "evenodd" }));
}
function PaperPlane24(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(PaperPlane24Svg, Object.assign({}, svgProps)));
}
exports.default = PaperPlane24;
//# sourceMappingURL=PaperPlane24.js.map